import { useState } from "react";
import { iniciarSesion, pedirEnlace } from "./authService";
import PantallaEntrada, { Alerta } from "./PantallaEntrada";
import { guardarSesion } from "./session";

// Entrar con correo y contraseña, o pedir el enlace para crear la contraseña (primera vez u olvido).
function Login({ onLogin, enlaceVencido = false }) {
  const [modo, setModo] = useState(enlaceVencido ? "enlace" : "entrar");
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [verPassword, setVerPassword] = useState(false);
  const [error, setError] = useState(enlaceVencido ? "El enlace venció o ya se usó. Pide uno nuevo." : "");
  const [enviado, setEnviado] = useState(false);
  const [cargando, setCargando] = useState(false);

  const cambiarModo = (nuevo) => {
    setModo(nuevo);
    setError("");
    setEnviado(false);
  };

  const entrar = async (e) => {
    e?.preventDefault();
    if (!correo.trim() || !password) {
      setError("Correo y contraseña requeridos");
      return;
    }
    setCargando(true);
    setError("");
    try {
      const usuario = await iniciarSesion(correo, password);
      guardarSesion(usuario);
      onLogin(usuario);
    } catch (e) {
      setError(e.message);
      setCargando(false);
    }
  };

  const enviarEnlace = async (e) => {
    e?.preventDefault();
    if (!correo.includes("@")) {
      setError("Escribe tu correo");
      return;
    }
    setCargando(true);
    setError("");
    try {
      await pedirEnlace(correo);
      setEnviado(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setCargando(false);
    }
  };

  const campoCorreo = (
    <div className="mb-5">
      <label htmlFor="correo" className="etiqueta">Correo</label>
      <input id="correo" type="email" value={correo} onChange={(e) => setCorreo(e.target.value)} className="campo"
        placeholder="tu@correo.com" inputMode="email" autoCapitalize="none" autoComplete="username" autoFocus
        disabled={cargando} />
    </div>
  );

  return (
    <PantallaEntrada>
      {modo === "entrar" ? (
        <form onSubmit={entrar} className="panel w-full max-w-sm p-8" noValidate>
          {campoCorreo}
          <div className="mb-6">
            <label htmlFor="password" className="etiqueta">Contraseña</label>
            <div className="relative">
              <input id="password" type={verPassword ? "text" : "password"} value={password}
                onChange={(e) => setPassword(e.target.value)} className="campo pr-20" placeholder="Ingresa tu contraseña"
                autoComplete="current-password" disabled={cargando} />
              <button type="button" onClick={() => setVerPassword(!verPassword)} aria-pressed={verPassword}
                className="absolute inset-y-0 right-3 my-auto h-7 rounded-full px-2 text-[10px] font-bold uppercase tracking-widest text-gray-400 transition hover:text-white">
                {verPassword ? "Ocultar" : "Ver"}
              </button>
            </div>
          </div>
          {error && <Alerta>{error}</Alerta>}
          <button type="submit" disabled={cargando} className="btn-primario btn-lg w-full">
            {cargando ? "Conectando..." : "Entrar"}
          </button>
          <button type="button" onClick={() => cambiarModo("enlace")}
            className="mt-5 w-full text-center text-xs text-gray-400 underline-offset-4 transition hover:text-white hover:underline">
            ¿Primera vez o olvidaste tu contraseña?
          </button>
        </form>
      ) : (
        <form onSubmit={enviarEnlace} className="panel w-full max-w-sm p-8" noValidate>
          <h2 className="mb-2 text-lg font-black uppercase tracking-tight text-white">Crear contraseña</h2>
          <p className="mb-5 text-sm text-gray-400">
            Escribe el correo con el que te registraron y te enviaremos un enlace para crear tu contraseña.
          </p>
          {campoCorreo}
          {error && <Alerta>{error}</Alerta>}
          {enviado ? (
            <Alerta tipo="ok">
              Si ese correo tiene acceso, en unos minutos te llegará el enlace. Revisa también el correo no deseado.
            </Alerta>
          ) : (
            <button type="submit" disabled={cargando} className="btn-primario btn-lg w-full">
              {cargando ? "Enviando..." : "Enviarme el enlace"}
            </button>
          )}
          <button type="button" onClick={() => cambiarModo("entrar")}
            className="mt-5 w-full text-center text-xs text-gray-400 underline-offset-4 transition hover:text-white hover:underline">
            Volver a entrar con mi contraseña
          </button>
        </form>
      )}
    </PantallaEntrada>
  );
}

export default Login;
